import { omit } from "lodash";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CollapsibleSidebarHandlerProps {
  configKey: string;
  sectionKey: string;
}
type CollapseConfig = Record<string, Record<string, boolean>>;

export interface CollapsibleSidebarStore {
  config: CollapseConfig;
  actions: {
    handler: ({ configKey, sectionKey }: CollapsibleSidebarHandlerProps) => void;
    setConfig: (config: CollapseConfig) => void;
  };
}

const initialState: Omit<CollapsibleSidebarStore, "actions"> = {
  config: {},
};

export const useCollapsibleSidebarStore = create<
  CollapsibleSidebarStore,
  [["zustand/persist", Partial<CollapsibleSidebarStore>]]
>(
  persist(
    (set) => ({
      ...initialState,
      actions: {
        setConfig: (config) => {
          set((state) => ({ ...state, config }));
        },
        handler: ({ configKey, sectionKey }) => {
          set((state) => {
            const sidebarState = state.config[configKey];
            return {
              ...state,
              config: {
                [configKey]: {
                  ...sidebarState,
                  [sectionKey]: sidebarState ? !sidebarState[sectionKey] : true,
                },
              },
            };
          });
        },
      },
    }),
    {
      name: "collapsible-sidebar-store",
      version: 1,
      partialize: (state) => {
        return Object.fromEntries(Object.entries(omit(state, "actions")));
      },
    }
  )
);
